import { render, staticRenderFns } from "./TaskListTutorial.vue?vue&type=template&id=0d34d056&"
import script from "./TaskListTutorial.vue?vue&type=script&lang=js&"
export * from "./TaskListTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports